export function managerConfirmation(record, details, name, now = new Date().toISOString()) {
  if (!name?.trim() || !['対面', 'ビデオ通話', '電話・音声通話'].includes(details.method)
    || !['異常なし', '要確認'].includes(details.visual) || !details.instruction?.trim() || !details.checked) {
    throw new Error('実際の確認方法・目視等の結果・指示事項と確認チェックを入力してください')
  }
  const review = Number(record.value) > 0 || details.visual === '要確認' || record.preDriveCheck?.status === 'review'
  return { ...record, confirmer: name, confirmationMethod: details.method, visualCheck: details.visual,
    presence: Number(record.value) > 0 || details.visual === '要確認', status: review ? 'review' : 'completed',
    instruction: details.instruction.trim(), note: `${record.note}\n${now} ${name}が${details.method}で確認。`,
    audit: [...(record.audit || []), `${now} ${name}が管理者確認（測定値・写真は変更なし）`] }
}
